var translation = {
	"Your profile": "您的個人資料",
	"View profile": "檢視個人資料",
	"Personal information": "個人資訊",
	"Community information": "社群資訊",
	"Workplace information": "工作空間資訊",
	"Email Preferences Center": "電子郵件偏好中心",
	"Builder ID privacy & data": "建構家 ID 隱私權和資料",
	"About profiles": "關於個人資料",
	"Welcome back": "歡迎回來",
	"Personal email address": "個人電子郵件地址",
	Email: "電子郵件",
	Edit: "編輯",
	Save: "儲存",
	"All fields marked with an asterisk (*) are required.": "所有標有星號 (*) 的欄位都是必填項目。",
	"Choose an option": "選擇一個選項",
	"Visible to others": "其他人可見",
	"Fields in this section will be visible to others.": "其他人可見此區段中的欄位。",
	"Display name": "顯示名稱",
	Alias: "別名",
	Bio: "簡介",
	"Github profile": "GitHub 設定檔",
	"Youtube profile": "Youtube 設定檔",
	"Facebook profile": "Facebook 設定檔",
	"re:Post profile": "re:Post 設定檔",
	"Dev:to profile": "re:Post 設定檔",
	"Link to blog": "連結到部落格",
	"LinkedIn profile": "LinkedIn 設定檔",
	"X profile": "X 設定檔",
	Social: "社群媒體",
	Username: "使用者名稱",
	"Add social link": "新增社群媒體連結",
	"Interest & background information": "興趣及背景介紹資訊",
	"Manage your interests and other information that are used in recommending content. ": "管理您的興趣和其他用於建議內容的資訊。",
	Interests: "興趣",
	"Search interests": "搜尋興趣",
	Country: "國家/地區",
	"State/province": "州/省",
	"Role type": "角色類型",
	"Industry focus": "產業焦點",
	"Level of AWS usage": "AWS 用量等級",
	"Use case focus": "使用案例焦點",
	"Manage your work information to accurately represent your organization.": "管理您的工作資訊以準確介紹您的組織。",
	"Business email address": "公司電子郵件地址",
	"Business phone number": "公司電話號碼",
	"Company website": "公司網站",
	"Job title": "職稱",
	"Company name": "公司名稱",
	"Company type": "公司類型",
	"Company size": "公司規模",
	"Project timeline": "專案時間軸",
	"Powered by Profile": "採用設定檔技術",
	About: "關於",
	"Make your profile": "建立您的個人資料",
	Profile: "設定檔",
	"Get started": "開始加入培訓",
	"Manage your information and preferences that are used to improve select AWS experiences.": "管理您的資訊和用於改善特定 AWS 體驗的偏好。",
	"Sign in/Get started": "登入/開始使用",
	"Key things to know": "重要須知事項",
	"Access experience": "存取體驗",
	"Control your data": "控制您的資料",
	"Read about privacy": "閱讀關於隱私權",
	"Email preference center": "電子郵件偏好中心",
	"This field is required.": "此欄位為必填項。",
	"Your profile helps improve your interactions with select AWS experiences.": "您的設定檔有助於改善您與特定 AWS 體驗的互動。",
	City: "城市",
	"Page topics": "頁面主題",
	"User information": "使用者資訊",
	"Full name": "全名",
	Discard: "捨棄",
	Link: "連結",
	"Short bio": "簡介",
	"Add interest": "新增關注",
	"Unsaved changes": "變更未儲存",
	"Please make a change before saving.": "請先變更後再進行儲存。",
	"Changes could not be saved.": "變更無法儲存。",
	"Your information has been saved.": "您的資訊已獲儲存。",
	"Your new Profile Picture": "您的新增設定檔圖片",
	"Profile Picture": "設定檔圖片",
	"Your profile picture makes you easily recognizable and shows when you're signed in.": "設定檔圖片可讓別人輕鬆識別您，並在您登入時加以顯示。",
	Cancel: "取消",
	"Save profile picture": "儲存設定檔圖片",
	"Change profile picture": "變更設定檔圖片",
	"Remove profile picture": "移除設定檔圖片",
	Zoom: "縮放",
	"20MB maximum file size, only .jpg, .jpeg, .png, .webp file types supported": "檔案大小上限 20MB，僅支援 .jpg、.jpeg、.png、.webp 等檔案類型",
	"Drag and drop": "拖放",
	"or browse files": "或瀏覽檔案",
	"or Browse files (browse files is link to open files)": "或瀏覽檔案 (「瀏覽檔案」是前往開啟檔案的連結)",
	"There was an error processing your profile picture, please try again.": "您的設定檔圖片在處理時發生錯誤，請再試一次。",
	"Your profile picture has been updated.": "您的設定檔圖片已更新。",
	"File size above 20MB.": "檔案大小超過 20MB。",
	"Invalid file type.": "無效的檔案類型。",
	"An error occurred.": "發生錯誤。",
	"Click or drag file to this area (backup from community in case we change our mind on drag and drop text)": "按一下檔案或將它拖曳到此區域 (從社群進行備份，以防我們改變拖放文字的想法)",
	"I agree to the terms of the <a href=#1 target=\"_blank\" rel=\"noopener noreferrer\">AWS Customer Agreement</a> and the <a href=#2 target=\"_blank\" rel=\"noopener noreferrer\">Statement on the Collection and Use of Personal Information.</a>": "我同意 <a href=#1 target=\"_blank\" rel=\"noopener noreferrer\">AWS 客戶協議</a> 的條款和 <a href=#2 target=\"_blank\" rel=\"noopener noreferrer\">關於個人資訊收集與使用的聲明。</a>",
	"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf": "https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf",
	"Sign into your profile": "登入您的個人資料",
	"Sign in": "登入",
	"First name": "名字",
	"Last name": "姓氏",
	"Phone number": "電話號碼",
	"Postal code": "郵遞區號",
	"Business address": "公司地址",
	Select: "選取",
	"Enter text": "輸入文字",
	"Business Interests": "商業利益",
	"Personal Interests": "個人興趣",
	"Manage your email through <a class=\"link\" href=\"https://profile.aws.amazon.com/#/profile/details\" rel=\"noopener noreferrer\" target=\"_blank\">AWS Builder ID</a>": "透過 <a class=\"link\" href=\"https://profile.aws.amazon.com/#/profile/details\" rel=\"noopener noreferrer\" target=\"_blank\">AWS 建構家 ID</a> 管理您的電子郵件",
	"Manage information that other members in the community will see when you create content on <a class=\"link\" href=\"https://builder.aws.com\">Builder Center</a> or leave comments on <a class=\"link\" href=\"https://aws.amazon.com/blogs\">AWS Blogs</a>.": "管理當您在 <a class=\"link\" href=\"https://builder.aws.com\" target=\"_blank\" rel=\"noopener noreferrer\">Builder Center</a> 上建立內容並在 <a class=\"link\" href=\"https://aws.amazon.com/blogs\" target=\"_blank\" rel=\"noopener noreferrer\">AWS 部落格</a>上留下評論時，社群中其他成員可見的資訊。",
	"Profile is used to improve select AWS experiences. <a href=#>Learn more</a>": "設定檔會用於改善特定 AWS 體驗。<a href=#>進一步了解</a>",
	"Profile is currently connected to select experiences, which includes <a href=#1>Builder Center</a>, <a href=#2>AWS Blogs</a>, <a href=#3>AWS Startups</a>, select forms and surveys on AWS Pulse, and select online webinar registrations and content downloads. ": "設定檔目前已連線到特定體驗，其中包括 <a href=#1 rel=\"noopener noreferrer\" target=\"_blank\">Builder Center</a>、<a href=#2 rel=\"noopener noreferrer\" target=\"_blank\">AWS 部落格</a>、<a href=#3 rel=\"noopener noreferrer\" target=\"_blank\">AWS Startups</a>、AWS Pulse 上的特定表單和問卷調查，以及特定線上網路研討會註冊和內容下載。",
	"You can access and update your profile at anytime by going to <a href=#>Profile</a>.": "您可以隨時移至<a href=#>設定檔</a>並存取和更新您的設定檔。",
	"There are unsaved changes in the <a href=\"#\">{{profile}}</a> section. Would you like to save or discard?": "<a href=\"#\">{{profile}}</a> 區段中有未儲存的變更。您想要儲存或捨棄？",
	or: "或",
	"browse files": "瀏覽檔案",
	"Claim your alias": "認領您的別名",
	"Your alias will be visible to all members of our community and is how other builders connect with you. Your alias cannot be changed after claiming.": "您的別名將對我們社群的所有成員可見，這是其他開發者與您聯繫的方式。別名在認領後無法更改。",
	"Enter your alias": "輸入您的別名",
	"Your alias must be 3 to 19 alphanumeric characters (contains only a-z, 0-9) and not violate our <a className=\"link\" href=\"#\" target=\"_blank\"> Terms and Services </a>.": "您的別名必須是3到19個字母數字字符（僅包含a-z、0-9），且不違反我們的<a className=\"link\" href=\"#\" target=\"_blank\">服務條款</a>。",
	"Are you sure you want to claim? This action cannot be undone.": "您確定要認領嗎？此操作無法撤銷。",
	Claim: "認領",
	Claimed: "已認領",
	"Checking availability": "正在檢查可用性",
	Claiming: "認領中",
	"Alias must be 3 to 19 characters.": "別名必須是3到19個字符。",
	"Alias must only contain alphanumeric characters (a-z, 0-9).": "別名只能包含字母數字字符（a-z、0-9）。",
	"Alias is already claimed.": "該別名已被認領。",
	"Unable to save your content.": "無法儲存您的內容。",
	"Your alias will be visible to all members of our community and is how other builders connect with you. Your alias <b>cannot</b> be changed after claiming.": "您的別名將對我們社群的所有成員可見，這是其他開發者與您聯繫的方式。別名在認領後<b>無法</b>更改。",
	"Please ensure all fields adhere to our <a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">Code of Conduct</a> before trying again.": "在重試之前，請確保所有欄位都符合我們的<a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">行為準則</a>。",
	"If you're still having trouble, feel free to <a class=\"link\" href=\"https://pulse.aws/application/V5ZJLDOL?p=0\" rel=\"noopener noreferrer\" target=\"_blank\">contact us</a> for assistance.": "如果您仍然遇到問題，請隨時<a class=\"link\" href=\"https://pulse.aws/application/V5ZJLDOL?p=0\" rel=\"noopener noreferrer\" target=\"_blank\">聯絡我們</a>獲取協助。",
	"Having trouble saving content?": "儲存內容時遇到問題？",
	"Checking alias availability was not successful. Please try again.": "檢查別名可用性失敗。請重試。",
	"This field contains invalid characters.": "此欄位包含無效字元。",
	"Select up to 10 interests": "最多選擇10個興趣",
	"Must be 7-15 digits.": "必須為7-15位數字。",
	"Invalid postal code. Postal codes may include only letters (A-Z and a-z), numbers (0-9), dashes (-), and spaces.": "郵遞區號無效。郵遞區號只能包含字母（A-Z和a-z）、數字（0-9）、破折號（-）和空格。",
	"This name is not valid. Names can include only letters (A-Z and a-z), numbers (0-9), dashes (-), and periods (.).": "此名稱無效。名稱只能包含字母（A-Z和a-z）、數字（0-9）、破折號（-）和句點（.）。",
	"Invalid email address": "無效的電子郵件地址",
	"Must be 64 characters or less": "必須為64個字元或更少",
	"Must be 100 characters or less": "必須為100個字元或更少",
	"2 more interests remaining.": "還可以選擇2個興趣。",
	"1 more interest remaining.": "還可以選擇1個興趣。",
	"You've reached the maximum number of interests. To add others, please remove an existing item.": "您已達到興趣的最大數量。要新增其他興趣，請刪除現有項目。",
	"Work city": "公司所在城市",
	"Work postal code": "公司所在郵遞區號",
	"I agree to the terms of the <a class=\"link\" href=\"https://aws.amazon.com/agreement/\" target=\"_blank\" rel=\"noopener noreferrer\">AWS Customer Agreement</a> and the <a class=\"link\" href=\"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">Statement on the Collection and Use of Personal Information.</a>": "我同意 <a class=\"link\" href=\"https://aws.amazon.com/agreement/\" target=\"_blank\" rel=\"noopener noreferrer\">AWS 客戶協議</a> 的條款和 <a class=\"link\" href=\"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">關於個人資訊收集與使用的聲明。</a>",
	Emails: "電子郵件",
	"AWS Builder ID": "AWS Builder ID",
	"Additional emails let you use different email addresses for select AWS experiences, while keeping your AWS Builder ID email for sign-in.": "您可以新增更多電子郵件地址以提升特定AWS服務的體驗，同時保留您的 AWS Builder ID 電子郵件以進行登入。",
	Personal: "個人",
	Business: "商務",
	None: "無",
	"Verify email": "驗證電子郵件",
	Unverified: "未驗證",
	"Add email": "新增電子郵件",
	"Add an email address": "新增電子郵件地址",
	"Enter verification code": "輸入驗證碼",
	"A 6-digit verification code has been sent to <span class=\"font-bold\">{{email}}</span>. Please enter it below to confirm your email address.": "6位驗證碼已傳送至 <span class=\"font-bold\">{{email}}</span>。請在下方輸入以確認您的電子郵件地址。",
	"Verification limit reached": "已達到驗證上限",
	"You've made the maximum number of requests allowed today. Please try again after 24 hours.": "您已達到今天的驗證次數上限。請於24小時後再試。",
	Okay: "確定",
	"Delete Email": "刪除電子郵件",
	"Are you sure you want to remove your email?": "您確定要刪除您的電子郵件嗎？",
	"Please type <span class=\"font-bold\">{{email}}</span> to continue with removal:": "請輸入 <span class=\"font-bold\">{{email}}</span> 以確認刪除：",
	"Didn't receive a code?": "沒收到驗證碼？",
	"Request a new code.": "請求新驗證碼。",
	"Additional emails": "額外電子郵件",
	Type: "類型",
	Skip: "跳過",
	Submit: "提交",
	"Emails are different": "請輸入上方所顯示的電子郵件地址",
	"Manage my AWS Builder ID": "管理我的 AWS Builder ID",
	"Your email address that you use to sign in and access different AWS experiences.": "您用於登入和存取不同 AWS 體驗的電子郵件地址。",
	"Email address": "電子郵件地址",
	"Email type": "電子郵件類型",
	"AWS Builder ID email": "AWS Builder ID 電子郵件",
	"If you did not receive an email, please check your spam or junk folder.": "如果您沒有收到電子郵件，請檢查您的垃圾郵件資料夾。",
	"No additional emails added.": "目前尚未新增其他電子郵件。",
	"Please enter a verification code.": "請輸入驗證碼。",
	"Verification code must be at least 6 characters": "驗證碼必須至少包含 6 個字元",
	"Federate email": "聯合登入電子郵件",
	"This information will update existing public details that other members in the community will see across <a class='link' href='https://repost.aws' rel='noopener noreferrer' target='_blank' >re:Post</a>, <a class='link' href='https://builder.aws.com' rel='noopener noreferrer' target='_blank' >Builder Center</a>, and comments on <a href='https://aws.amazon.com/blogs/' class='link' rel='noopener noreferrer' target='_blank' >AWS Blogs</a>. Please make sure to follow <a href='https://aws.amazon.com/codeofconduct/' class='link' rel='noopener noreferrer' target='_blank' >code of conduct</a> when saving your community information.": "此資訊將會更新現有的公開詳細資訊，而社群中其他成員可以在 <a class='link' href='https://repost.aws' rel='noopener noreferrer' target='_blank' >re:Post</a>、<a class='link' href='https://builder.aws.com' rel='noopener noreferrer' target='_blank' >建構者中心</a>和 <a href='https://aws.amazon.com/blogs/' class='link' rel='noopener noreferrer' target='_blank' >AWS 部落格</a>上的評論中看到這些資訊。儲存社群資訊時，請務必遵守<a href='https://aws.amazon.com/codeofconduct/' class='link' rel='noopener noreferrer' target='_blank' >行為準則</a>。",
	"Display country": "可見國家",
	"Display state": "可見州",
	Headline: "標題",
	"Email marketing preferences": "電子郵件行銷偏好設定",
	"Select a verified email to manage your email marketing preferences.": "選取已驗證的電子郵件來管理您的電子郵件行銷偏好設定。",
	Manage: "管理",
	"Email preferences": "電子郵件偏好設定"
};
var zhTW = {
	translation: translation
};

export { zhTW as default, translation };
